export default "__VITE_ASSET__BObjxN_Y__"